<mat-expansion-panel hideToggle class="verification-tipsv2-container">
  <mat-expansion-panel-header>
    <mat-panel-title class="text-navy-800 be-text-md">
      <svg
        viewBox="0 0 100 100"
        class="notification-icon notification-icon--information"
      >
        <use href="assets/icons-v2/sprites.svg#information-circle-bold"></use>
      </svg>
      <p class="verification-tipsv2__title">
        Didn’t receive a code?
        <span>Click here for help</span>
      </p>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ul class="verification-tipsv2">
    <li class="verification-tipsv2__item">
      If you selected email, please check your junk or spam folder.
    </li>
    <li class="verification-tipsv2__item">
      If you are using a landline phone or a mobile number that you cannot
      access,
      <a routerLink="/register/enroll">click here to register again</a> and
      select your email.
    </li>
    <li class="verification-tipsv2__item">
      Or you can
      <button class="btn-link-v2" (click)="onClick()" type="button">
        click here and resend the code</button
      >.
    </li>
  </ul>
</mat-expansion-panel>
